// extracted by mini-css-extract-plugin
module.exports = {"col":"actions_col_1Zr-f","buttonMobile":"actions_buttonMobile_1eClU"};